<template>
  <div class="main-box">
    <img src="../assets/banner.png" alt="" class="banner-img" />
    <List
      v-model="loading"
      :finished="finished"
      @load="onLoad"
      :immediate-check="false"
      finished-text="没有更多了"
    >
      <div v-for="(itm, index) in list" :key="index" class="news-item">
        <NewsItem :item="itm" @navTo="goDetail" />
      </div>
    </List>
  </div>
</template>

<script>
import NewsItem from '@/components/next/NewsItem.vue';
import { getNews, getBaseInfo } from '../api/index.ts';
import { List } from 'vant';

export default {
  components: {
    NewsItem,
    List,
  },

  data() {
    return {
      loading: false,
      finished: false,
      list: [],
      page: 1,
      classId: '',
    };
  },
  async created() {
    const ret = await getBaseInfo();
    this.classId = ret.data.classId;
    await this.onLoad();
  },
  methods: {
    onLoad() {
      this.loading = true;
      getNews(this.page, '全部', this.classId).then((res) => {
        this.page = this.page + 1;
        if (res.statusCode === 404) {
          this.finished = true;
        } else {
          if (!res.data.data || res.data.data.length === 0) {
            this.finished = true;
          } else {
            if (!res.data.data[0].list || res.data.data[0].list.length === 0) {
              this.finished = true;
            } else {
              this.list = [...this.list, ...res.data.data[0].list];
            }
          }
        }
        this.loading = false;
      });
    },
    goDetail(a) {
      const url = a.targetUrl;
      window.location.href = url;
    },
  },
};
</script>

<style lang="less" scoped>
.main-box {
  min-height: 100vh;
  background: #f7f9f4;
}
.banner-img {
  width: 100%;
  margin-bottom: 15px;
}
.news-item {
  padding: 0 13px;
}
</style>